/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-material-source': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.112.313h2.423c.257 0 .465.208.465.465v8.444a.465.465 0 0 1-.465.465H.465A.465.465 0 0 1 0 9.222V.778C0 .52.208.313.465.313h6.647zm-.623.93h-2.99l.75 2.704h1.435l.805-2.705zm-3.955 0l.915 3.294c.056.2.24.34.448.34H6.03a.465.465 0 0 0 .445-.332l.983-3.303H9.07v7.515H.93V1.242h1.604zm4.403 5.053c.257 0 .465.224.465.5 0 .246-.165.45-.381.492l-.084.008h-4.04c-.256 0-.464-.223-.464-.5 0-.245.164-.45.381-.491l.084-.009h4.039z" _fill="#fff"/>'
  }
})
